import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=ccccb438&"
import script from "./AppVersion.vue?vue&type=script&lang=js&"
export * from "./AppVersion.vue?vue&type=script&lang=js&"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=ccccb438&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports